import { observer } from "mobx-react-lite";
import React, { useState, FormEvent, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Button, CheckboxProps, Form, Grid, Input, Segment } from "semantic-ui-react";
import { IJobPosition } from "../../../app/models/jobposition";
import JobPositionStore from "../../../app/stores/jobpositionStore";

const JobPositionCreateForm: React.FC<RouteComponentProps> = ({ history }) => {
  const jobpositionStore = useContext(JobPositionStore);
  const { createJobPosition, submitting, loadCertificates, certificatesSearch, searchCertificate } = jobpositionStore;

  // useEffect(() => {
  //   loadCertificates();
  // }, []);

  const [newJobPosition, setNewJobPosition] = useState<IJobPosition>({
    id: "",
    createdAt: "",
    updatedAt: "",
    name: "",
    description: "",
    certificateId: '',
    url: "",
  });

  const [isCheck, setIsCheck] = useState([] as any);
  const [term, setTerm] = useState("");

  const handleSubmit = () => {
    createJobPosition(newJobPosition, isCheck).then(() => {
      history.push(`/hrmanagement/jobposition`);
    });
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setNewJobPosition({ ...newJobPosition, [name]: value });
  };

  const handleSearch=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchCertificate(event.currentTarget.value);
  }

  const handleClick = (id: any, data: CheckboxProps) => {
    setIsCheck([...isCheck, id]);
    if (!data.checked) {
      setIsCheck(isCheck.filter((item: any) => item !== id));
    }
    
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="Name"
          required
          onChange={handleInputChange}
          name="name"
          placeholder="Name"
          value={newJobPosition.name}
        />
        <Form.Input
          label="Description"
          onChange={handleInputChange}
          name="description"
          placeholder="Description"
          value={newJobPosition.description}
        />
        <Form.Input
          label="File URL"
          onChange={handleInputChange}
          name="url"
          placeholder="File URL"
          value={newJobPosition.url}
        />

        <Input  type="text" icon="search" placeholder="Search certificate" onChange={handleSearch} value={term}/>
        <Grid>
        <br></br>
        <Grid.Column width={5} as={Segment}>
         <h5> Enable Skill: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Enable Skill') && <Form.Checkbox
            label={certificate.name}
            checked={isCheck.includes(certificate.id)}
            onClick={(e, data) => handleClick(certificate.id, data)}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5> Induction:</h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Induction') && <Form.Checkbox
            label={certificate.name}
            checked={isCheck.includes(certificate.id)}
            onClick={(e, data) => handleClick(certificate.id, data)}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  License: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'License') && <Form.Checkbox
            label={certificate.name}
            checked={isCheck.includes(certificate.id)}
            onClick={(e, data) => handleClick(certificate.id, data)}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={5} as={Segment}>
        <h5> Certificate: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Certificate') && <Form.Checkbox
            label={certificate.name}
            checked={isCheck.includes(certificate.id)}
            onClick={(e, data) => handleClick(certificate.id, data)}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  Police Check & Soft Skills: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Police Check' || certificate.category === 'Soft Skill') && <Form.Checkbox
            label={certificate.name}
            checked={isCheck.includes(certificate.id)}
            onClick={(e, data) => handleClick(certificate.id, data)}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        </Grid>
        <br/><br/>
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/hrmanagement/jobposition")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(JobPositionCreateForm);
